export async function uploadFile({ data, filename }: { data: Blob; filename: string }) {
  const form = new FormData(); form.append('file', data, filename);
  const response = await fetch('/api/files', { method: 'POST', credentials: 'same-origin', headers: { 'x-staff-hub-csrf': 'same-origin' }, body: form });
  const value = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(value.message || 'Upload failed');
  return value as { fileUrl: string; sha256: string; bytes: number };
}
